import React from "react";
import {
  Select,
  MenuItem,
  SelectChangeEvent,
  InputAdornment,
  styled,
} from "@mui/material";
import { getCompatibleUnits } from "../../../../utils/units";

const StyledSelect = styled(Select<string>)(({ theme }) => ({
  "& .MuiSelect-select": {
    paddingTop: 4,
    paddingBottom: 4,
    paddingLeft: 8,
    paddingRight: 24,
    backgroundColor: theme.palette.action.hover,
    borderRadius: theme.shape.borderRadius,
    fontSize: "0.875rem",
    "&:focus": {
      backgroundColor: theme.palette.action.hover,
    },
  },
  "& .MuiOutlinedInput-notchedOutline": {
    border: "none",
  },
}));

interface CompactUnitSelectProps {
  value: string;
  onChange: (value: string) => void;
  quantity?: number;
  sourceUnit?: string;
}

export const CompactUnitSelect: React.FC<CompactUnitSelectProps> = ({
  value,
  onChange,
  quantity,
  sourceUnit,
}) => {
  const handleChange = (event: SelectChangeEvent<string>) => {
    onChange(event.target.value as string);
  };

  const baseUnit = sourceUnit || value;

  return (
    <InputAdornment position="end">
      <StyledSelect
        value={value}
        onChange={handleChange}
        variant="outlined"
        size="small"
      >
        {getCompatibleUnits(baseUnit).map((unit) => (
          <MenuItem key={unit} value={unit}>
            {unit}
          </MenuItem>
        ))}
      </StyledSelect>
    </InputAdornment>
  );
};
